import styled from 'styled-components';
import Search from '../../assets/onboarding/search.svg';

const SearchIcon = styled(Search as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.5rem'};
  height: ${props => props.height || '2.5rem'};
  fill: ${props => props.fill || props.theme.colors.black.base};
  display: flex;
`;

export default SearchIcon;
